export const ATTACHMENTS_SEARCH_FOLDER_DISTINGUISH_NAME = 'attachmentsSearchFolder';
